import './style.sass';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonUsualText from '../../../common-components/common-usual-text';

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper isMargin={false}>
                <div className="rukami-process__content">
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="rukami-process__item">
                            <div className="rukami-process__item-info">
                                <CommonTitle className="rukami-process__item-title">
                                    Процесс
                                </CommonTitle>
                                <CommonSmallText className="rukami-process__paragraph">
                                    У фестиваля Rukami уже был сайт rukamifest.com. Но не был
                                    рассчитан на большие нагрузки. По сути, это был простой
                                    информационный сайт с минимальным функционалом.
                                </CommonSmallText>
                            </div>
                            <img
                                className="rukami-process__img"
                                src="/images/pic/rukami/process1.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                А в 2020 году из-за коронавируса фестиваль перенесли в онлайн. Чтобы
                                провести все онлайн-активности «по одному адресу», заказчик решил
                                сделать из старого сайта сложную платформу с системой личных
                                кабинетов, интеграцией с Youtube для прямых трансляций, игровыми
                                элементами. Платформа должна была заменить собой полноценный
                                офлайн-фестиваль и выдержать нагрузку в 50 тысяч посетителей
                                единовременно.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="rukami-process__item">
                            <CommonSmallTitle className="rukami-process__item-title">
                                Новый концепт
                            </CommonSmallTitle>
                            <CommonUsualText className="rukami-process__paragraph">
                                Сайт – это город будущего Метаполис.
                            </CommonUsualText>
                            <img
                                className="rukami-process__img"
                                src="/images/pic/rukami/process2.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                В городе есть разные локации (они же - треки программы фестиваля):
                                Гравити Холл, Диджитаун, Технокампус, Кибер-гарден, Тесла театр,
                                Сайенс Хилл. А еще Трибуна для защиты конкурсных проектов, Квеструм
                                с видеоквестом, Погружение (3D-инсталляция с музыкой), Галерея
                                (выставка цифрового искусства), Метапорт с видео-экскурсиями,
                                Селфипарк для селфи зрителей и многое другое.
                            </CommonSmallText>
                            <img
                                className="rukami-process__img"
                                src="/images/pic/rukami/process5.jpg"
                                alt=""
                                loading="lazy"
                            />
                            <CommonSmallText>
                                Чтобы принять участие в онлайн-фестивале, пользователь
                                регистрируется по email или через соцсети и начинает получать
                                игровую валюту Метаполиса – метакоины. В дни проведения фестиваля их
                                можно потратить на видеоквест и другие активности. Кроме того,
                                количество метакоинов определяет место участника в общем рейтинге.
                            </CommonSmallText>
                            <div className="rukami-process__img-wrap">
                                <img
                                    className="rukami-process__img"
                                    src="/images/pic/rukami/process3.jpg"
                                    alt=""
                                    loading="lazy"
                                />
                                <img
                                    className="rukami-process__img"
                                    src="/images/pic/rukami/process4.jpg"
                                    alt=""
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="rukami-process__item">
                            <CommonSmallTitle className="rukami-process__item-title">
                                Как сделана платформа?
                            </CommonSmallTitle>
                            <CommonSmallText className="rukami-process__paragraph">
                                UI приложение на React содержит в себе пользовательский интерфейс
                                для всех сервисов проекта: регистрации пользователей, личного
                                кабинета, портала, активностей. Является точкой входа на проект для
                                всех пользователей. Реализовано как SPA на React. Работает по
                                HTTP/HTTPS-протоколу, запрашивая данных с бэкенд-сервисов через API.
                            </CommonSmallText>
                            <CommonSmallText className="rukami-process__paragraph">
                                Участники фестиваля могут общаться между собой, используя сервис
                                обмена сообщениями. Это приложение с интенсивным обменом данными на
                                Nodejs, с использованием фреймворков Express и Socket.IO. Сервис
                                обмена сообщениями работает асинхронно по HTTP/HTTPS-протоколу,
                                через WebSocket, напрямую взаимодействуя с базой данных.
                            </CommonSmallText>
                            <img
                                className="rukami-process__img rukami-process__img--first"
                                src="/images/pic/rukami/process6.jpg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="rukami-process__item"></div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
            <div className="rukami-process__item personal-area">
                <FullWrapper>
                    <CommonSmallTitle className="rukami-process__subtitle">
                        Система личных кабинетов
                    </CommonSmallTitle>
                    <CommonSmallText>
                        Зарегистрированный пользователь может добавить свой проект на фестивальный
                        конкурс, предложить спикера или другую активность в программу. Пользователь
                        с правами администратора проверяет предложенные проекты и дает по ним свои
                        комментарии, составляет публичную афишу, может выгружать базы данных,
                        исправлять чужие учётки (менять роль пользователя).
                    </CommonSmallText>
                </FullWrapper>
                <div className="personal-area__content-wrap">
                    <FullWrapper>
                        <div className="personal-area__content">
                            <div className="personal-area__column">
                                <div className="personal-area__item">
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={50}
                                        animateOnce={true}
                                        duration={1}
                                    >
                                        <img
                                            className="personal-area__img"
                                            src="/images/pic/rukami/personal-area1.jpg"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </ScrollAnimation>
                                </div>
                            </div>
                            <div className="personal-area__column">
                                <div className="personal-area__item">
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={50}
                                        animateOnce={true}
                                        duration={1}
                                    >
                                        <img
                                            className="personal-area__img"
                                            src="/images/pic/rukami/personal-area2.jpg"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </ScrollAnimation>
                                </div>
                                <div className="personal-area__item">
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={50}
                                        animateOnce={true}
                                        duration={1}
                                    >
                                        <img
                                            className="personal-area__img"
                                            src="/images/pic/rukami/personal-area3.jpg"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </ScrollAnimation>
                                </div>
                            </div>
                            <div className="personal-area__column">
                                <div className="personal-area__item">
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={50}
                                        animateOnce={true}
                                        duration={1}
                                    >
                                        <img
                                            className="personal-area__img"
                                            src="/images/pic/rukami/personal-area4.jpg"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </ScrollAnimation>
                                </div>
                                <div className="personal-area__item">
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={50}
                                        animateOnce={true}
                                        duration={1}
                                    >
                                        <img
                                            className="personal-area__img"
                                            src="/images/pic/rukami/personal-area5.jpg"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </FullWrapper>
                </div>
            </div>
        </ScrollAnimation>
    );
};

export default Process;
